import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import './locationAutocomplete.css';

// Campo de texto com sugestões de país (lista completa, filtro local) ou cidade (busca no backend).
// O texto exibido é controlado pelo pai; ao escolher uma sugestão, `onSelect` recebe o objeto { id, name }.
const LocationAutocomplete = ({ kind, value, onChange, onSelect, name, placeholder, disabled }) => {
  const { listCountry, listCity } = useAuxiliaries();
  const isCountry = kind === 'country';

  const [countries, setCountries] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [shouldSearchCity, setShouldSearchCity] = useState(false);

  useEffect(() => {
    if (!isCountry) return;
    const fetchCountries = async () => {
      try {
        const response = await listCountry();
        setCountries(response?.results || []);
      } catch (error) {
        console.error('Erro ao buscar países:', error);
      }
    };
    fetchCountries();
  }, [isCountry, listCountry]);

  useEffect(() => {
    if (isCountry) return;
    const query = String(value || '').trim();

    if (!shouldSearchCity || query.length < 3) {
      setSuggestions([]);
      return;
    }

    const debounce = setTimeout(async () => {
      try {
        const cityResponse = await listCity({ name: query });
        setSuggestions(cityResponse?.results || []);
      } catch (error) {
        console.error('Erro ao buscar cidades por nome:', error);
        setSuggestions([]);
      }
    }, 350);

    return () => clearTimeout(debounce);
  }, [isCountry, value, shouldSearchCity, listCity]);

  const handleInputChange = (event) => {
    const query = event.target.value;
    onChange(query);
    if (isCountry) {
      setSuggestions(
        query.trim() === ''
          ? []
          : countries.filter((c) => c.name.toLowerCase().includes(query.toLowerCase()))
      );
    } else {
      setShouldSearchCity(true);
    }
  };

  const handleSelect = (item) => {
    onSelect(item);
    setSuggestions([]);
    setShouldSearchCity(false);
  };

  return (
    <div className="location-autocomplete">
      <input
        type="text"
        name={name}
        value={value || ''}
        onChange={handleInputChange}
        onBlur={() => setSuggestions([])}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
      />
      {suggestions.length > 0 && (
        <ul className="location-autocomplete__list">
          {suggestions.map((item) => (
            <li
              key={item.id}
              // onMouseDown dispara antes do blur do input, evitando fechar a lista antes da seleção
              onMouseDown={(event) => {
                event.preventDefault();
                handleSelect(item);
              }}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

LocationAutocomplete.propTypes = {
  kind: PropTypes.oneOf(['country', 'city']).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default LocationAutocomplete;
